import { AbstractControl, ValidatorFn } from '@angular/forms';
import _ from 'lodash';

export function NumberRangeValidator(min: number, max: number, controlName: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    const hasMin = !isNaN(Number(min));
    const hasMax = !isNaN(Number(max));

    if (_.isNil(control.value) || (!hasMin && !hasMax)) {
      return null;
    }

    let isWithinRange;
    let validationMessage;

    if (hasMin && hasMax) {
      isWithinRange = control.value >= min && max >= control.value;
      validationMessage = `${controlName} must be between ${min} and ${max}`;
    } else if (hasMin) {
      isWithinRange = control.value >= min;
      validationMessage = `${controlName} must be greater than or equal to ${min}`;
    } else if (hasMax) {
      isWithinRange = max >= control.value;
      validationMessage = `${controlName} must be less than or equal to ${max}`;
    }

    return isWithinRange ? null : { numberRange: validationMessage };
  };
}
